
<app-content-header backLabel="app_cancel" (backEvent)="onBack()"
[headline]="'drafts' | i18next"></app-content-header>

<div cass="row">
  <div class="col-12">
    <div class="card card-nb">
      <div class="card-body">
        <div>
          <div class="h3 mb-1">
            {{ 'port_phonenumber_drafts' | i18next }}
          </div>
          <div class="subinformations" [innerHTML]="'port_number_draft_text' | i18next:{id, name: instancename}"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row align-items-stretch">
  @for (draft of drafts; track draft) {
    <div class="col-12 col-lg-6 mb-3">
      <app-order-draft-card
        [draft]="draft"
        [instancename]="instancename"
        [showCreate]="true"
        [showDelete]="true"
        [company]="company"
        (delete)="onDeleteDraft($event)"
        (continue)="onContinueDraft($event)"
      ></app-order-draft-card>
    </div>
  }
</div>

<div class="d-flex justify-content-end mt-2 mb-5">
  <button class="btn btn-outline-primary" (click)="onContinueNew()">{{ 'port_draft_continue_new' | i18next}}</button>
</div>